import { request } from "./request";
import * as apiConstants from "../constants/Api";

export const fetchMe = () => {
  return request("get", `${apiConstants.SERVER_URL}/form-service/me`).then(
    user => {
      if (user.status === apiConstants.STATUS_EXPIRED_PASSWORD) {
        window.location.replace(apiConstants.PASSWORD_CHANGE_URL);
      }

      return user;
    },
    error => {
      return false;
    }
  );
};
